export default "__VITE_ASSET__CkLpCXVE__"